import React from 'react';
import ReadNotification from 'src/features/TopMenu/Notification/ReadNotification';
import UnReadNotification from 'src/features/TopMenu/Notification/UnReadNotification';
import DropdownLoader from 'src/components/Loader/DropdownLoader';
import { isEmpty } from 'ramda';
import Menu from '@mui/material/Menu';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import SiteSettings from 'src/siteSetting';
import { mapIndexed } from 'src/utilities/visualFieldsMapper';

interface Props {
  readNotifications: any;
  unReadNotifications: any;
  unReadMsgCount: any;
  isDropDown: any;
  setIsDropDown: any;
}

const useStyles = makeStyles(() => ({
  notifHeader: {
    display: 'flex',
  },
  menu: {
    top: 15,
    '& .MuiList-root': {
      paddingTop: 0,
      paddingBottom: 0,
    },
    '& .MuiPaper-root': {
      overflow: 'initial',
      position: 'relative',
      boxShadow: '0px 5px 7px rgba(0, 0, 0, 0.05)',
      width: '420px',
      maxHeight: 225,
      '&::before': {
        display: 'block',
        position: 'absolute',
        content: '""',
        width: 14,
        height: 14,
        backgroundColor: 'white',
        transform: 'rotate(45deg)',
        borderTopLeftRadius: 5,
        top: -7,
        right: 20,
        borderLeft: `1px solid ${SiteSettings.buttonBorderColor()}`,
        borderTop: `1px solid ${SiteSettings.buttonBorderColor()}`,
        zIndex: 1,
      },
    },
  },
}));

const NotificationDropdown: React.FC<Props> = (props: Props) => {
  const {
    isDropDown,
    unReadMsgCount,
    readNotifications,
    unReadNotifications,
    setIsDropDown,
  } = props;

  const classes = useStyles();

  const open = Boolean(isDropDown);

  return (
    <Menu
      anchorEl={isDropDown}
      open={open}
      onClose={() => setIsDropDown(false)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      classes={{
        root: classes.menu,
      }}
      autoFocus={false}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <Box
        sx={{
          maxHeight: 215,
          overflow: 'scroll',
          scrollbarWidth: 'none',
          borderRadius: '5px',
          border: `1px solid ${SiteSettings.buttonBorderColor()}`,
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        <Box p="8px 16px" className={classes.notifHeader}>
          <Typography fontWeight={600} variant="caption" flex={1} fontSize={'16px'}>
            Notifications
          </Typography>
          <Typography fontWeight={600} variant="caption" display="inline" fontSize={'14px'}>
            {unReadMsgCount}&nbsp;
          </Typography>
          <Typography variant="caption" display="inline" fontSize={'14px'}>
            New message
          </Typography>
        </Box>

        {mapIndexed((notification: any, index: number) => {
          return <UnReadNotification key={index} notification={notification} />;
        }, unReadNotifications)}
        {mapIndexed((readNotification: any, index: number) => {
          return (
            <ReadNotification key={index} notification={readNotification} />
          );
        }, readNotifications)}
        {isEmpty(unReadNotifications) ? <DropdownLoader /> : null}
      </Box>
    </Menu>
  );
};

export default NotificationDropdown;
